(() => {
  const ingredientsShowcasesEls = document.querySelectorAll('[data-ingredients-showcase]');

  const init = () => {
    if (!window.ingredientsShowcaseInit) {
      window.ingredientsShowcaseInit = true;

      document.addEventListener('scroll', () => {
        Array.from(ingredientsShowcasesEls).forEach((ingredientsShowcasesEl) => {
          if (isInViewport(ingredientsShowcasesEl)) {
            ingredientsShowcasesEl.classList.add('visible');
          }
        });
      });
    }
  }

  const isInViewport = (el) => {
    const rect = el.getBoundingClientRect();

    return rect.top <= window.innerHeight / 1.5;
  }

  document.addEventListener("DOMContentLoaded", init);
})();